import React from "react";
import { useAuth } from "ackbox-weblib-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const FrontPage = () => {
  const auth = useAuth();
  return (
    <section className="hero is-primary">
      <div className="hero-body">
        <div className="container has-text-centered">
          <h1 className="title is-1 mb-6 is-spaced">Ackbox <strong>Xpenser</strong></h1>
          <p className="subtitle is-3">The easiest way to put your finances in order.</p>
          <p className="subtitle is-4 mb-6">Designed with simplicity and privacy in mind.</p>
          <div className="box m-6">
            <p><FontAwesomeIcon icon="search-dollar" size={"10x"} color="white"/></p>
          </div>
          <div className="columns is-mobile">
            <div className="column has-text-right">
              <button className="button is-outlined is-light" onClick={() => auth.signIn()}>Sign In
              </button>
            </div>
            <div className="column has-text-left">
              <button className="button is-outlined is-light" onClick={() => auth.signIn()}>Sign Up
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
